import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import Swal from "sweetalert2";
import axios from "axios";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { Spinner } from "reactstrap";
import { imprimirTicketVenta } from "../../Admin/Ventas/PDFTicketUtil";

const DEFAULT_EMPRESA = "64554028db17c2f7f0a771c2";
const DEFAULT_COMPRADOR = "6776c839c763d45da2f0f5b7";
const DEFAULT_SOCIEDAD = "6775c905d688145c579d8393";

function VentaDirectaCreate() {
  const { user } = useContext(AuthContext);

  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const hoyStr = moment().format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);

  const [value, setValue] = useState(null); // cliente
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedMarca, setSelectedMarca] = useState("");
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [fecha, setFecha] = useState(hoyStr);
  const [observaciones, setObservaciones] = useState("NA");
  const [pedidoCliente, setPedidoCliente] = useState("");
  const [alumno, setAlumno] = useState("");
  const [formaPago, setFormaPago] = useState("");

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      articulosNombre: "",
      colores: "",
      coloresNombre: "",
      tallas: "",
      tallasNombre: "",
      cantidad: 0,
      precio: 0,
      total: 0,
      inventarios: "",
      disponible: 0,
      inventariosArticulo: [],
    },
  ]);

  const [totalPiezas, setTotalPiezas] = useState(0);
  const [totalGeneral, setTotalGeneral] = useState(0);
  const [validaBoton, setValidaBoton] = useState(true);
  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  useEffect(() => {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    Promise.all([
      axios.get(URL_CLIENTES, { headers }),
      axios.get(URL_ARTICULOS, { headers }),
      axios.get(URL_AREAS, { headers }),
      axios.get(URL_MARCAS, { headers }),
      axios.get(URL_COLABORADORES, { headers }),
    ])
      .then(([cl, ar, areasResp, mc, co]) => {
        setClientes(cl.data);
        setArticulos(ar.data);
        setAreas(areasResp.data);
        setMarcas(mc.data);
        setColaboradores(co.data);
      })
      .catch((err) => console.error(err));
  }, []);

  const recalcTotales = (rows) => {
    let tp = 0;
    let tg = 0;
    rows.forEach((r) => {
      tp += parseFloat(r.cantidad) || 0;
      tg += parseFloat(r.total) || 0;
    });
    setTotalPiezas(tp);
    setTotalGeneral(parseFloat(tg.toFixed(2)));
  };

  const fetchInventariosArticulo = async (rowId, articuloId, areaId) => {
    if (!articuloId || !areaId) {
      setInputFields((prev) =>
        prev.map((f) =>
          f.id === rowId
            ? { ...f, inventariosArticulo: [], inventarios: "", disponible: 0 }
            : f
        )
      );
      return;
    }
    try {
      const { data } = await axios.get(
        `${URL_INVENTARIOS}Articulo/${articuloId}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      const filtrados = (data || []).filter((inv) => {
        const ar = inv.areas?.[0]?._id || inv.areas?.[0];
        const cantidad = Number(inv.cantidad) || 0;
        return String(ar) === String(areaId) && cantidad > 0;
      });

      setInputFields((prev) =>
        prev.map((f) =>
          f.id === rowId
            ? { ...f, inventariosArticulo: filtrados }
            : f
        )
      );
    } catch (err) {
      console.error("Error consultando inventario:", err);
    }
  };

  const getColoresDisponibles = (row) => {
    const map = new Map();
    (row?.inventariosArticulo || []).forEach((inv) => {
      const c = inv.colores?.[0];
      if (!c) return;
      const id = String(c._id || c);
      if (!map.has(id)) {
        map.set(id, { _id: id, name: c.name || "" });
      }
    });
    return Array.from(map.values()).sort((a, b) =>
      (a.name || "") > (b.name || "") ? 1 : -1
    );
  };

  const getTallasDisponibles = (row) => {
    if (!row?.colores) return [];
    const map = new Map();
    (row?.inventariosArticulo || []).forEach((inv) => {
      const c = inv.colores?.[0];
      const t = inv.tallas?.[0];
      if (!c || !t) return;
      if (String(c._id || c) !== String(row.colores)) return;
      const id = String(t._id || t);
      if (!map.has(id)) {
        map.set(id, {
          _id: id,
          name: t.name || "",
          variantesTallas: Array.isArray(t.variantesTallas)
            ? t.variantesTallas
            : [],
        });
      }
    });
    return Array.from(map.values()).sort((a, b) =>
      (a.name || "") > (b.name || "") ? 1 : -1
    );
  };

  const formatTallaLabel = (opt) => {
    if (!opt) return "";
    const base = String(opt.name || "").trim();
    const vars = Array.isArray(opt.variantesTallas) ? opt.variantesTallas : [];
    const vs = vars
      .map((v) =>
        String(v?.name || v?.nombre || v?.descripcion || "").trim()
      )
      .filter(Boolean)
      .join(", ");
    return vs ? `${base} (${vs})` : base;
  };

  const resolveInventario = (row, colorId, tallaId) => {
    if (!colorId || !tallaId) return { id: "", cantidad: 0 };
    const inv = (row?.inventariosArticulo || []).find((i) => {
      const c = i.colores?.[0];
      const t = i.tallas?.[0];
      return (
        String(c?._id || c) === String(colorId) &&
        String(t?._id || t) === String(tallaId)
      );
    });
    return { id: inv?._id || "", cantidad: Number(inv?.cantidad) || 0 };
  };

  const handleAddField = () => {
    setInputFields((prev) => [
      ...prev,
      {
        id: uuidv4(),
        articulos: "",
        articulosNombre: "",
        colores: "",
        coloresNombre: "",
        tallas: "",
        tallasNombre: "",
        cantidad: 0,
        precio: 0,
        total: 0,
        inventarios: "",
        disponible: 0,
        inventariosArticulo: [],
      },
    ]);
  };

  const handleRemoveField = (rowId) => {
    setInputFields((prev) => {
      const next = prev.filter((f) => f.id !== rowId);
      recalcTotales(next);
      return next;
    });
  };

  const handleChangeArticulo = async (rowId, art) => {
    const articuloId = art?._id || "";
    setInputFields((prev) =>
      prev.map((f) => {
        if (f.id !== rowId) return f;
        // TK7 — precargar el precio del artículo (queda editable)
        const precioArt = parseFloat(art?.precio) || 0;
        return {
          ...f,
          articulos: articuloId,
          articulosNombre: art
            ? `${art.codigo || ""} ${art.descripcion || ""}`.trim()
            : "",
          precio: precioArt,
          total: parseFloat(
            ((parseFloat(f.cantidad) || 0) * precioArt).toFixed(2)
          ),
          colores: "",
          coloresNombre: "",
          tallas: "",
          tallasNombre: "",
          inventarios: "",
          disponible: 0,
          inventariosArticulo: [],
        };
      })
    );

    if (!articuloId) return;
    if (!selectedArea) {
      Swal.fire(
        "Atención",
        "Selecciona primero el almacén para ver el inventario disponible.",
        "info"
      );
      return;
    }
    await fetchInventariosArticulo(rowId, articuloId, selectedArea);
  };

  const handleChangeColor = (rowId, color) => {
    const colorId = color?._id || "";
    setInputFields((prev) =>
      prev.map((f) =>
        f.id === rowId
          ? {
              ...f,
              colores: colorId,
              coloresNombre: color?.name || "",
              tallas: "",
              tallasNombre: "",
              inventarios: "",
              disponible: 0,
            }
          : f
      )
    );
  };

  const handleChangeTalla = (rowId, talla) => {
    const tallaId = talla?._id || "";
    setInputFields((prev) =>
      prev.map((f) => {
        if (f.id !== rowId) return f;
        const { id, cantidad } = resolveInventario(f, f.colores, tallaId);
        return {
          ...f,
          tallas: tallaId,
          tallasNombre: formatTallaLabel(talla),
          inventarios: id,
          disponible: cantidad,
        };
      })
    );
  };

  const handleChangeCantidad = (rowId, valor) => {
    setInputFields((prev) => {
      const next = prev.map((f) => {
        if (f.id !== rowId) return f;
        const cantidad = parseFloat(valor) || 0;
        const total = parseFloat((cantidad * (parseFloat(f.precio) || 0)).toFixed(2));
        return { ...f, cantidad, total };
      });
      recalcTotales(next);
      return next;
    });
  };

  const handleChangePrecio = (rowId, valor) => {
    setInputFields((prev) => {
      const next = prev.map((f) => {
        if (f.id !== rowId) return f;
        const precio = parseFloat(valor) || 0;
        const total = parseFloat((precio * (parseFloat(f.cantidad) || 0)).toFixed(2));
        return { ...f, precio, total };
      });
      recalcTotales(next);
      return next;
    });
  };

  const articuloSeleccionado = (rowId) =>
    articulos.find((a) => a._id === inputFields.find((f) => f.id === rowId)?.articulos);

  const validarRows = () => {
    if (!value?._id) return "Selecciona un cliente.";
    if (!selectedArea) return "Selecciona el almacén / área.";
    if (!selectedMarca) return "Selecciona una marca.";
    if (!selectedColaborador) return "Selecciona un vendedor.";
    if (!pedidoCliente.trim()) return "Captura el folio del pedido cliente.";
    if (!inputFields.length) return "Agrega al menos un artículo.";
    for (const f of inputFields) {
      if (!f.articulos) return "Selecciona el artículo en todas las filas.";
      if (!f.colores) return "Selecciona color en todas las filas.";
      if (!f.tallas) return "Selecciona talla en todas las filas.";
      const cantidad = parseFloat(f.cantidad) || 0;
      if (cantidad <= 0) return "La cantidad debe ser mayor a 0.";
      if (!f.inventarios)
        return `No hay inventario para ${f.articulosNombre} (${f.coloresNombre}/${f.tallasNombre}) en esa área.`;
      if (cantidad > Number(f.disponible || 0))
        return `Stock insuficiente para ${f.articulosNombre} (${f.coloresNombre}/${f.tallasNombre}). Disponible: ${f.disponible}.`;
    }
    return null;
  };

  const guardar = async (e) => {
    e.preventDefault();
    const err = validarRows();
    if (err) {
      Swal.fire("Atención", err, "warning");
      return;
    }
    setValidaBoton(false);
    toggleProgreso();

    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    try {
      const totalCantidad = inputFields.reduce(
        (s, f) => s + (parseFloat(f.cantidad) || 0),
        0
      );
      const totalImporte = parseFloat(
        inputFields
          .reduce((s, f) => s + (parseFloat(f.total) || 0), 0)
          .toFixed(2)
      );

      // 1) Pedido
      const pedidoBody = {
        fecha,
        fechaCreacion: hoyStr,
        resurtido: "No",
        clientes: value._id,
        colaboradores: selectedColaborador,
        empresas: DEFAULT_EMPRESA,
        fecha_cancelacion: fecha,
        fecha_confirmacion: fecha,
        pendFechaConf: "0",
        observaciones: observaciones || "NA",
        total_general: totalImporte,
        total_piezas: totalCantidad,
        pedidoCliente: pedidoCliente.trim() || "VD",
        compradores: DEFAULT_COMPRADOR,
        surtido: totalCantidad,
        pendiente_surtir: 0,
        confirmacionPedido: "Si",
        status: "Cerrado",
        marcas: selectedMarca,
        descuento: 0,
        autorizacionSurtir: "Si",
        autorizacionSurtirFecha: hoyStr,
        sociedades: DEFAULT_SOCIEDAD,
        impuestos: "No",
        esVentaDirecta: "Si",
        alumno: alumno?.trim() || "NA",
        formaPago: formaPago || "NA",
      };
      const pedResp = await axios.post(URL_PEDIDOS, pedidoBody, { headers });
      const pedidoId = pedResp.data._id;

      // 2) Surtido
      const surtidoBody = {
        fecha,
        pedidos: pedidoId,
        empresas: DEFAULT_EMPRESA,
        user: user.id,
        areas: selectedArea,
        observaciones: observaciones || "NA",
        total_general: totalImporte,
        saldo: totalImporte,
        subTotal: totalImporte,
        iva: 0,
        impuestos: 0,
        descuento: 0,
        clientes: value._id,
        colaboradores: selectedColaborador,
        totalCantidad: totalCantidad,
        sociedades: DEFAULT_SOCIEDAD,
        is_active: "Si",
        esVentaDirecta: "Si",
        alumno: alumno?.trim() || "NA",
        formaPago: formaPago || "NA",
      };
      const surResp = await axios.post(URL_SURTIDOS, surtidoBody, { headers });
      const surtidoId = surResp.data._id;

      // 3) ArticulosPedido + ArticulosSurtidos por cada fila
      for (const row of inputFields) {
        const cantidad = parseFloat(row.cantidad) || 0;
        const precio = parseFloat(row.precio) || 0;
        const total = parseFloat((cantidad * precio).toFixed(2));

        const apResp = await axios.post(
          URL_ARTICULOS_PEDIDO,
          {
            pedidos: pedidoId,
            articulos: row.articulos,
            colores: row.colores,
            tallas: row.tallas,
            resurtido: "No",
            cantidad,
            surtido: cantidad,
            pendiente_surtir: 0,
            precio,
            descuento: 0,
            total,
            pendienteCortar: 0,
            cortado: cantidad,
            sociedades: DEFAULT_SOCIEDAD,
          },
          { headers }
        );
        const articulosPedidoId = apResp.data._id;

        await axios.post(
          URL_ARTICULOS_SURTIDOS,
          {
            surtidos: surtidoId,
            inventarios: row.inventarios,
            cantidad,
            articulos: row.articulos,
            pedidos: pedidoId,
            articulosPedido: articulosPedidoId,
            colores: row.colores,
            tallas: row.tallas,
            areas: selectedArea,
            sociedades: DEFAULT_SOCIEDAD,
            precio,
            total,
          },
          { headers }
        );
      }

      await axios.post(
        URL_LOGS,
        {
          tipo: "Crear Venta Directa",
          detalle: `${value._id} ${totalImporte}`,
          user: user.id,
        },
        { headers }
      );

      Swal.fire({
        icon: "success",
        title: "Listo!",
        text: "Venta directa creada con éxito",
        showConfirmButton: false,
        timer: 1200,
      });

      // ===== Imprimir ticket automaticamente =====
      try {
        const cli = value;
        const clientesNombre =
          cli?.nombre_comercial ||
          cli?.razon_social ||
          `${cli?.nombre || ""} ${cli?.apellido || ""}`.trim() ||
          "";

        const colab = colaboradores.find(
          (c) => String(c._id) === String(selectedColaborador)
        );
        const vendedorNombre = colab
          ? `${colab.nombre || ""} ${colab.apellido || ""}`.trim()
          : "";
        const sucursalNombre =
          colab?.sucursales?.[0]?.alias ||
          colab?.sucursales?.[0]?.name ||
          "";

        await imprimirTicketVenta({
          fecha,
          clientes: clientesNombre,
          observaciones: observaciones || "NA",
          numero: pedResp.data.idPedido,
          idPDFOC: surtidoId,
          pedidoCliente: pedidoCliente.trim() || "VD",
          subTotal: totalImporte,
          iva: 0,
          total_general: totalImporte,
          totalCantidad,
          descuento: 0,
          nombreColaborador: vendedorNombre,
          sucursalColaborador: sucursalNombre,
          areaColaborador: "",
          numeroColaborador: "",
          entregadoCon: "",
          esVentaDirecta: "Si",
          alumno: alumno?.trim() || "",
          formaPago: formaPago || "",
          vendedor: vendedorNombre,
          idPedido: pedResp.data.idPedido,
          autoPrint: true,
        });
      } catch (printErr) {
        console.error("No se pudo imprimir el ticket:", printErr);
      }

      setTimeout(() => {
        window.location.href = "/ListadoPedidos";
      }, 1500);
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Ocurrió un error al guardar la venta directa.",
        footer: `${error?.response?.data || ""}`,
      });
      setValidaBoton(true);
      setModalProgreso(false);
    }
  };

  return (
    <>
      <Header />
      <br />
      {user.menu_pedidos ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuVentas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
          </Row>
          <br />
          <h3 align="center">Crear Venta Directa</h3>
          <br />
          <Form onSubmit={guardar}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  value={fecha}
                  required
                  onChange={(e) => setFecha(e.target.value)}
                />
              </Col>
              <Col md={3}>
                <Label>Cliente</Label>
                <Autocomplete
                  size="small"
                  value={value}
                  onChange={(_, v) => setValue(v)}
                  options={clientes.sort((a, b) =>
                    (a.nombre_comercial || "") > (b.nombre_comercial || "") ? 1 : -1
                  )}
                  getOptionLabel={(opt) => opt?.nombre_comercial || ""}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" placeholder="Cliente" />
                  )}
                />
              </Col>
              <Col md={2}>
                <Label>Almacen</Label>
                <Input
                  type="select"
                  value={selectedArea}
                  required
                  onChange={async (e) => {
                    const nuevaArea = e.target.value;
                    setSelectedArea(nuevaArea);
                    const filas = inputFields;
                    setInputFields((prev) =>
                      prev.map((f) => ({
                        ...f,
                        colores: "",
                        coloresNombre: "",
                        tallas: "",
                        tallasNombre: "",
                        inventarios: "",
                        disponible: 0,
                        inventariosArticulo: [],
                      }))
                    );
                    if (nuevaArea) {
                      for (const f of filas) {
                        if (f.articulos) {
                          await fetchInventariosArticulo(
                            f.id,
                            f.articulos,
                            nuevaArea
                          );
                        }
                      }
                    }
                  }}
                >
                  <option value="">Selecciona</option>
                  {areas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => (
                      <option value={a._id} key={a._id}>
                        {a.name}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Marca</Label>
                <Input
                  type="select"
                  value={selectedMarca}
                  required
                  onChange={(e) => setSelectedMarca(e.target.value)}
                >
                  <option value="">Selecciona</option>
                  {marcas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => (
                      <option value={a._id} key={a._id}>
                        {a.name}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Vendedor</Label>
                <Input
                  type="select"
                  value={selectedColaborador}
                  required
                  onChange={(e) => setSelectedColaborador(e.target.value)}
                >
                  <option value="">Selecciona</option>
                  {colaboradores
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => (
                      <option value={a._id} key={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    ))}
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <Label>Pedido Cliente</Label>
                <Input
                  type="text"
                  value={pedidoCliente}
                  required
                  onChange={(e) => setPedidoCliente(e.target.value)}
                />
              </Col>
              <Col md={4}>
                <Label>Nombre</Label>
                <Input
                  type="text"
                  value={alumno}
                  placeholder="Nombre"
                  onChange={(e) => setAlumno(e.target.value)}
                />
              </Col>
              <Col md={4}>
                <Label>Forma de Pago</Label>
                <Input
                  type="select"
                  value={formaPago}
                  onChange={(e) => setFormaPago(e.target.value)}
                >
                  <option value="">Selecciona</option>
                  <option value="01">01 Efectivo</option>
                  <option value="02">02 Cheque nominativo</option>
                  <option value="03">03 Transferencia electronica de fondos</option>
                  <option value="04">04 Tarjeta de credito</option>
                  <option value="05">05 Monedero electronico</option>
                  <option value="06">06 Dinero electronico</option>
                  <option value="08">08 Vales de despensa</option>
                  <option value="12">12 Dacion en pago</option>
                  <option value="13">13 Pago por subrogacion</option>
                  <option value="14">14 Pago por consignacion</option>
                  <option value="15">15 Condonacion</option>
                  <option value="17">17 Compensacion</option>
                  <option value="23">23 Novacion</option>
                  <option value="24">24 Confusion</option>
                  <option value="25">25 Remision de deuda</option>
                  <option value="26">26 Prescripcion o caducidad</option>
                  <option value="27">27 A satisfaccion del acreedor</option>
                  <option value="28">28 Tarjeta de debito</option>
                  <option value="29">29 Tarjeta de servicios</option>
                  <option value="30">30 Aplicacion de anticipos</option>
                  <option value="31">31 Intermediario pagos</option>
                  <option value="99">99 Por definir</option>
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Label>Observaciones</Label>
                <Input
                  type="text"
                  value={observaciones}
                  onChange={(e) => setObservaciones(e.target.value)}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={3}>Artículo</Col>
              <Col md={2}>Color</Col>
              <Col md={2}>Talla</Col>
              <Col md={1}>Disp.</Col>
              <Col md={1}>Cantidad</Col>
              <Col md={1}>Precio</Col>
              <Col md={1}>Total</Col>
              <Col md={1}></Col>
            </Row>
            {inputFields.map((f) => {
              const art = articuloSeleccionado(f.id);
              return (
                <Row key={f.id} className="align-items-center text-center mb-2">
                  <Col md={3}>
                    <Autocomplete
                      size="small"
                      value={art || null}
                      onChange={(_, v) => handleChangeArticulo(f.id, v)}
                      options={articulos.sort((a, b) =>
                        (a.codigo || "") > (b.codigo || "") ? 1 : -1
                      )}
                      getOptionLabel={(opt) =>
                        `${opt?.codigo || ""} ${opt?.descripcion || ""}`.trim()
                      }
                      renderInput={(params) => (
                        <TextField {...params} variant="outlined" placeholder="Artículo" />
                      )}
                    />
                  </Col>
                  <Col md={2}>
                    {(() => {
                      const coloresOpts = getColoresDisponibles(f);
                      return (
                        <Autocomplete
                          size="small"
                          value={
                            coloresOpts.find((c) => c._id === f.colores) || null
                          }
                          onChange={(_, v) => handleChangeColor(f.id, v)}
                          options={coloresOpts}
                          getOptionLabel={(opt) => opt?.name || ""}
                          disabled={!f.articulos || !coloresOpts.length}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder={
                                f.articulos && !coloresOpts.length
                                  ? "Sin stock"
                                  : "Color"
                              }
                            />
                          )}
                        />
                      );
                    })()}
                  </Col>
                  <Col md={2}>
                    {(() => {
                      const tallasOpts = getTallasDisponibles(f);
                      return (
                        <Autocomplete
                          size="small"
                          value={
                            tallasOpts.find((t) => t._id === f.tallas) || null
                          }
                          onChange={(_, v) => handleChangeTalla(f.id, v)}
                          options={tallasOpts}
                          getOptionLabel={formatTallaLabel}
                          renderOption={(opt) => formatTallaLabel(opt)}
                          disabled={!f.colores || !tallasOpts.length}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder={
                                f.colores && !tallasOpts.length
                                  ? "Sin stock"
                                  : "Talla"
                              }
                            />
                          )}
                        />
                      );
                    })()}
                  </Col>
                  <Col md={1}>
                    <Input
                      type="text"
                      value={f.disponible}
                      disabled
                      style={{
                        color:
                          f.disponible > 0 && f.cantidad <= f.disponible
                            ? "green"
                            : "red",
                      }}
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={f.cantidad}
                      onChange={(e) => handleChangeCantidad(f.id, e.target.value)}
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={f.precio}
                      onChange={(e) => handleChangePrecio(f.id, e.target.value)}
                    />
                  </Col>
                  <Col md={1}>
                    <Input type="number" step="any" value={f.total} disabled />
                  </Col>
                  <Col md={1}>
                    <Button
                      size="sm"
                      color="danger"
                      type="button"
                      onClick={() => handleRemoveField(f.id)}
                      disabled={inputFields.length === 1}
                    >
                      <i className="fas fa-minus"></i>
                    </Button>{" "}
                    <Button
                      size="sm"
                      color="info"
                      type="button"
                      onClick={handleAddField}
                    >
                      <i className="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              );
            })}
            <br />
            <Row>
              <Col md={6}>
                <h4>
                  TOTALES {new Intl.NumberFormat("en-US").format(totalPiezas)} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(totalGeneral)}
                </h4>
              </Col>
              <Col md={6} className="text-end">
                <Button type="submit" color="success" disabled={!validaBoton}>
                  Guardar Venta Directa
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      ) : null}

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Procesando</h4>
        </ModalHeader>
        <ModalBody>
          <h5>Por favor espere...</h5>
          <div className="progreso">
            <Spinner style={{ width: "40px", height: "40px", color: "#232B41" }} />
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default VentaDirectaCreate;
